import { ConfirmModalDescriptor, RegisterConfirmModal } from "./types";
import { noop } from "../../../../globalConsts";
import { StackControls } from "../useModalStack";

export const useRegisterConfirmModal = (
  controls: StackControls
): RegisterConfirmModal => {
  const { pushDescriptorToStack, removeDescriptorFromStack } = controls;

  return (text, config) => {
    const { title } = config || {};

    const descriptor: ConfirmModalDescriptor = {
      type: "confirm",
      title,
      text,
      resolve: noop,
    };

    const promise = new Promise<boolean>((resolve) => {
      descriptor.resolve = (confirmed: boolean): void => {
        resolve(confirmed);
        removeDescriptorFromStack(descriptor);
      };
    });

    pushDescriptorToStack(descriptor);

    return promise;
  };
};
